import React from 'react'
import PropTypes from 'prop-types'
import { Box, ThemeProvider } from '@deseretbook/react-ui'
import PromoContent from './PromoContent'

const ProductSidebarCallout = ({ content }) => {
  return (
    <ThemeProvider>
      <Box paddingTop={1}>
        <PromoContent content={content} />
      </Box>
    </ThemeProvider>
  )
}

ProductSidebarCallout.propTypes = {
  content: PropTypes.string,
}

ProductSidebarCallout.defaultProps = {
  content: 'default',
}

export default ProductSidebarCallout
